import { render, staticRenderFns } from "./LeadersVision.vue?vue&type=template&id=f31ab784&scoped=true&"
import script from "./LeadersVision.vue?vue&type=script&lang=js&"
export * from "./LeadersVision.vue?vue&type=script&lang=js&"
import style0 from "./LeadersVision.vue?vue&type=style&index=0&id=f31ab784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31ab784",
  null
  
)

export default component.exports